import React from 'react';

const Footer = () => {
    let aboutLink = laravel.platform_settings.About_Link;

    return (
        <div className="wripple-footer mt-auto">

            <p>
                &#169; {new Date().getFullYear()} {laravel.platform_name}, All Rights Reserved
            </p>

            {TB.isString(aboutLink) && aboutLink.length > 0 && (
                <a href={aboutLink} target="_blank">About {laravel.platform_name}</a>
            )}
        </div>
    );
};

export default Footer;